export default {
    pathForImages: (state, getters, rootState) => {
        return `static/images/default/`
    },
    sharedPath: (state, getters, rootState) => {
        return `static/images/shared/`
    },
    pathForPartnerBranding: (state, getters, rootState) => {
      return `branding/start/`
    },
}
